import React, { useMemo } from "react";

import TrplWrapper from "./TrplWrapper";
import convert from 'react-from-dom';
import ParseHTML from "../../ParseHTML";

function CellCustomComponentPropsAreEqual(prevProps, nextProps) {
  return prevProps.mode === nextProps.mode
    && prevProps.individuals.trpls === nextProps.individuals.trpls;
};

export default React.memo(({
  node,
  mode,
  trpls,
  nodeId,
  account,
  isEmbed,
  classes,
  rstIndex,
  nodeIndex,
  individuals,
  custom_component,
  openTrplFormFull,
  onRstTypeBtnClick,
  openTrplFormWithRst,
  onNodeRemoveBtnClick,
  collectTrplsByChainAndNode,
}) => {

  return (
    <div style={{ minHeight: '21px' }} key={nodeIndex}>
    {custom_component && custom_component.map((row, rowIndex) => {
      return (
        <div className={`${classes.alignCenter}`} key={rowIndex}>
          {row && row.children.map((column, columnIndex) => {
            return (
              <div key={columnIndex}>
                {column && column.children.map((item, index) => {

                  const collectedTrpls = item && item.originalPid && item.type !== 'text' && item.compType !== 'title' ?
                    useMemo(() => collectTrplsByChainAndNode(item.originalPid, trpls, individuals),
                      [trpls, individuals]) : [];
                    const trplsSid = collectedTrpls.length ? collectedTrpls[0].sid : null;
                    const trplKey = trplsSid ? `${trplsSid}.${index}` : index;

                    let conceptTrpls;
                    if (item.type === 'text' && item.value && /\d/.test(item.value))
                      conceptTrpls = trpls;

                  return (
                    <div key={trplKey} style={{ paddingRight: collectedTrpls.length ? '1px' : ''}}>
                      {item.type === 'text' ? (
                        /<\/?[a-z][\s\S]*>/i.test(item.value) ?
                          <ParseHTML
                            htmlString={item.value}
                            variables={conceptTrpls}
                          />
                        :
                          <div style={{ fontSize: '12px', padding: '1px' }}>{convert(item.value)}</div>
                        )
                      : item.compType === 'title' ?
                        <div
                          className={`${classes.alignCenter} ${classes.nowrap}`}
                          style={{ color: '#4c4c4c', height: '21px' }} //paddingBottom: '1px', fontSize: '12px',
                        >
                          <span style={{ padding: '1px 0 3px 0' }}>{item.title}</span>
                        </div>
                      :
                      <div key={trplKey} style={{ minHeight: '21px' }}>
                        <TrplWrapper
                          rst={item}
                          node={node}
                          mode={mode}
                          trplKey={trplKey}
                          nodeId={nodeId}
                          account={account}
                          isEmbed={isEmbed}
                          classes={classes}
                          pidIndex={index}
                          rstIndex={rstIndex}
                          collectedTrpls={collectedTrpls}
                          openTrplFormFull={openTrplFormFull}
                          onRstTypeBtnClick={onRstTypeBtnClick}
                          openTrplFormWithRst={openTrplFormWithRst}
                          onNodeRemoveBtnClick={onNodeRemoveBtnClick}
                          individualsNodes={individuals && individuals.nodes}
                        />
                        {/* <span style={{ fontSize: '8px' }}>oid{trplsAncestorNode} sid{trplsSid}</span> */}
                        </div>
                      }
                    </div>
                  )
                })}
              </div>
            )
          })}
        </div>
      )
    })}
    </div>
  )
}, CellCustomComponentPropsAreEqual);
